<template>
  <div class="chinaEuropeTrain">
    <Header :typeHeader="'defaultHeader'">
      <!-- banner -->
      <img slot="headerImage" :src="imgList.bannerImg" alt="" />
      <!-- 标题 -->
      <div slot="headerTitle">{{$store.state.navShow == true ? '“冀欧号”中欧班列':'"Ji-ou" China-Europe Railway Express'}}</div>
      <div
        style="
          font-size: 1.125rem;
          color: #ffffff;
          font-weight: 100;
          margin-top: 0.6rem;
        "
        slot="headerTitle"
      >
        {{$store.state.navShow == true ? '河北省首趟直通德国的中欧班列':'"the first direct China-Europe freight train from Hebei Province to Germany'}}
      </div>
    </Header>

    <div class="TopTitle" data-aos="fade-up">
      <div class="">
        {{$store.state.navShow == true ? $route.name : $route.meta.EnName}}
      </div>
    </div>
    <div class="ContentText" data-aos="fade-down">
     <p>
        {{$store.state.navShow == true ? 'MG集团凭借多年的国际物流供应链资源优势及在俄罗斯本土不断积累的行业和客户资源，通过专业化团队运作及和精细化管理运营模式，立足河北省石家庄国际陆港，打造了河北省首个直通德国的铁路运输线。“冀欧号”中欧班列于2021年4月17日首发开行，该线路由石家庄，经俄罗斯莫斯科、直达波兰马拉舍维奇，德国汉堡、杜伊斯堡，目前已达到常态化发行。':'With years of international logistics supply chain resource and industry and customer resources accumulated in Russia, MG Group has built the first railway transportation line directly to Germany in Hebei Province based on Shijiazhuang International land port through professional team operation and fine management and operation mode. The "Ji-Ou" China-Europe freight train was first launched on April 17, 2021. The line runs through Shijiazhuang, Moscow, Russia, Marashevich, Poland, Hamburg and Duisburg, Germany, and now is regularly issued.'}}
      </p>
      <p>
        {{$store.state.navShow == true ? 'MG集团将打造以国际铁路为重心的国际多式联运服务，打造中欧精品班列、中俄班列及中亚班列，以专业化、精品化打造中欧班列双循环模式。同时提供订舱、集装箱租赁、单证、清关及相关配套服务。':'MG Group will build international multimodal transport service with international railway as the focus, build High-quality china-Europe, China-Russia and Central Asia freight trains, and create a double-cycle model of china-Europe freight trains with specialization and quality. And we provide booking, container leasing, documents, customs clearance and related supporting services at the same time.'}}
      </p>
    </div>

    <div class="ContenImg">
      <img :src=" $store.state.navShow == true ? imgList.advantageImg: imgList.advantageImgE" />
    </div>
    <div class="ContentDataNumber" :style="$store.state.navShow == true ? 'height: 10.6rem;' : 'height: 12.6rem;'">
      <div class="ContentDataNumberImage" data-aos="fade-letf">
        <img :src="imgList.trainImg" />
      </div>
      <div class="ContentDataNumberText" data-aos="fade-up">
        <div class="title">{{$store.state.navShow == true ? '常态化运营路线':'Normal operation route'}}</div>
        <div class="text">
          {{$store.state.navShow == true ? '全程':'Whole Journey'}}
          <countTo
            :startVal="0"
            :endVal="11000"
            separator=""
            :duration="3000"
          ></countTo>
          {{ $store.state.navShow == true ?  'KM，经二连浩特口岸出入境 覆盖欧洲' : 'KM, and it enters and exits through Erlianhot and Manzhouli ports, covering'}}
          <countTo
            :startVal="0"
            :endVal="10"
            separator=""
            :duration="3000"
          ></countTo>
          {{$store.state.navShow == true ? '个国家和':'European countries and more than'}}
          <countTo
            :startVal="0"
            :endVal="60"
            separator=""
            :duration="3000"
          ></countTo>
          {{$store.state.navShow == true ? '多个地区。': 'regions.'}}
        </div>

        <div class="number">
          <div
            class="numberList"
            v-for="(item, index) in $store.state.navShow == true ? numDataList : numDataListE "
            :key="index"
          >
            <div class="numberText">
              <!-- 	{{ item.num }} -->
              <countTo
                :startVal="0"
                separator=""
                :endVal="Number(item.num)"
                :duration="3000"
              ></countTo>
            </div>
            <div class="numberName">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="roadLine_bottom_L">
      <div class="firstTable">
        <!-- :resizable="false" 防止表格左右拉动 -->
        <el-table class="Table" :data=" $store.state.navShow == true ? tableData1 : tableData1E" border style="width: 100%">
          <el-table-column
            prop="name"
            :label="$store.state.navShow == true ? '石家庄高邑站-欧洲':'Shijiazhuang Gaoyi Station - Europe'"
            :resizable="false"
          >
            <!-- width="120" -->
          </el-table-column>
          <el-table-column prop="kilometer" :label="$store.state.navShow == true ? '里程':'Mileage'" :resizable="false">
            <!-- width="80" -->
          </el-table-column>
          <el-table-column prop="shixiao" :label="$store.state.navShow == true ? '时效':'Aging'" :resizable="false">
            <!-- width="115" -->
          </el-table-column>
          <el-table-column prop="pinci" :label="$store.state.navShow == true ? '频次':'Frequency'" :resizable="false">
            <!-- width="60" -->
          </el-table-column>
        </el-table>
      </div>
      <!-- 铁路双循环路线 第二个表格 -->
      <div class="secondTable">
        <p class="tableTitleP">{{$store.state.navShow == true ? '铁路双循环路线':'Railway double loop route'}}</p>
        <el-table class="Table" :data="$store.state.navShow == true ? tableData2 : tableData2E" border style="width: 100%">
          <el-table-column
            prop="startStation"
             :label="$store.state.navShow == true ?'起始站':'Starting station'"
            :resizable="false"
          >
            <!-- width="110" -->
          </el-table-column>
          <el-table-column prop="licheng"  :label="$store.state.navShow == true ?'里程':'Mileage'" :resizable="false">
            <!-- width="70" -->
          </el-table-column>
          <el-table-column prop="shixiao" :label="$store.state.navShow == true ?'时效':'Aging'" :resizable="false">
            <!-- width="105" -->
          </el-table-column>
          <el-table-column
            prop="goBackPinCi"
            :label="$store.state.navShow == true ?'去程/回程频次':'Outbound/Return frequency'"
            :resizable="false"
          >
            <!-- width="100" -->
          </el-table-column>
        </el-table>
      </div>
      <!-- 其他国际铁运路线  -->
      <div class="">
        <p class="tableTitleP">{{$store.state.navShow == true ? '其他国际铁运路线':'Other international railway lines'}}</p>
        <div class="lineDiv">
          <p class="firstP">{{$store.state.navShow == true ? '上海/天津/宁波/长沙':'Shanghai/Tianjin/Ningbo/Changsha'}}</p>
          <p class="zhi">{{$store.state.navShow == true ? '至':'to'}}</p>
          <p class="thirdP">{{$store.state.navShow == true ? '莫斯科/明斯克/马拉舍维奇/杜伊斯堡/汉堡':'Moscow/Minsk/Malashevich/Duisburg/Hamburg'}}</p>
        </div>
      </div>
    </div>

    <!-- 提供服务 -->

    <div class="ButtomService">
      <p class="tableTitleP">{{$store.state.navShow == true ?'提供服务':'Providing services'}}</p>
      <div class="topOne" data-aos="fade-up">
        <div class="topImg" >
          <img :src="serviveItemsArr.one.titleImg" />
          <div class="topTitle">
            {{$store.state.navShow == true ? serviveItemsArr.one.titleWord :serviveItemsArr.oneE.titleWord  }}
          </div>
        </div>
        <div class="topContent">
          {{ $store.state.navShow == true ? serviveItemsArr.one.Desc :  serviveItemsArr.oneE.Desc}}
        </div>
      </div>
	    <div class="topOne" data-aos="fade-up">
        <div class="topImg" >
          <img :src="serviveItemsArr.ones.titleImg" />
          <div class="topTitle">
            {{ $store.state.navShow == true ? serviveItemsArr.ones.titleWord : serviveItemsArr.onesE.titleWord }}
          </div>
        </div>
        <div class="topContent">
          {{ $store.state.navShow == true ? serviveItemsArr.ones.Desc :serviveItemsArr.onesE.Desc }}
        </div>
      </div>
      <div class="topTwo">
        <div
          class="topTwoCon"
          v-for="(item, index) in $store.state.navShow == true ? serviveItemsArr.list : serviveItemsArr.listE"
          :key="index"
          data-aos="fade-up"
          :style="$store.state.navShow == true ? 'height: 4.6875rem;' : 'height: 7.6875rem;'"
        >
          <div class="topImg">
            <img :src="item.titleImg" />
            <div class="topTitle">
              {{ item.titleWord }}
            </div>
          </div>
          <div class="topContent">
            {{ item.Desc }}
          </div>
        </div>
      </div>
    </div>

    <div class="buttonImgCET">
      <img src="../../../assets/chinaEurope/chinaEurope07.png" />
    </div>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
// 引入数字滚动的依赖(插件)
import countTo from "vue-count-to";
export default {
  components: {
    Header,
    countTo,
  },
  data() {
    return {
      imgList: {
        bannerImg: require("@/assets/chinaEurope/banner1.jpg"),
        advantageImg: require("@/assets/chinaEurope/chinaEurope01.png"),
        advantageImgE: require("@/assets/chinaEurope/chinaEurope01_E.png"),
        trainImg: require("@/assets/chinaEurope/chinaEurope05.png"),
      },
      numDataList: [
        {
          num: "11000",
          name: "全程(KM)",
        },
        {
          num: "10",
          name: "覆盖亚欧国家",
        },
        {
          num: "60",
          name: "覆盖亚欧地区",
        },
      ],
      numDataListE: [
        {
          num: "11000",
          name: "Whole Journey(KM)",
        },
        {
          num: "10",
          name: "Covering countries in Asia and Europe",
        },
        {
          num: "60",
          name: "Covering regions in Asia and Europe",
        },
      ],
      // 第一个表格
      tableData1: [
        {
          name: '马拉舍维奇(Mala)',
          kilometer: '9800km',
          shixiao: '站到站约14天(days)',
          pinci: '4-8次/月'
        },
        {
          name: '杜伊斯堡(DIT)',
          kilometer: '11000km',
          shixiao: '站到站约18天(days)',
          pinci: '4-8次/月'
        },
        {
          name: '汉堡(HAM)',
          kilometer: '11000km',
          shixiao: '站到站约18天(days)',
          pinci: '4-8次/月'
        },
        {
          name: '石家庄 - 莫斯科(MOS)',
          kilometer: '8000km',
          shixiao: '站到站约12天(days)',
          pinci: '4次/月'
        }
      ],
      tableData1E: [
       {
          name: 'Malasevic(Mala)',
          kilometer: '9800km',
          shixiao: 'Station to station about 14 days(days)',
          pinci: '4-8 times/month'
        },
        {
          name: 'Duisburg(DIT)',
          kilometer: '11000km',
          shixiao: 'Station to station about 18 days（days）',
          pinci: '4-8 times/month'
        },
        {
          name: 'Hamburger(HAM)',
          kilometer: '11000km',
          shixiao: 'Station to station about 18 days（days）',
          pinci: '4-8 times/month'
        },
        {
          name: 'Shijiazhuang-Moscow（MOS）',
          kilometer: '8000km',
          shixiao: 'Station to station about 12 days（days）',
          pinci: '4 times/month'
        }
      ],
      // 第二个表格
      tableData2: [
        {
          startStation: '天津 - 莫斯科',
          licheng: '8000km',
          shixiao: '站到站约14天(days)',
          goBackPinCi: '4次/月'
        },
        {
          startStation: '石家庄 - 莫斯科',
          licheng: '8000km',
          shixiao: '站到站约14天(days)',
          goBackPinCi: '4次/月'
        }
      ],
     tableData2E: [
        {
          startStation: 'Tianjin-Moscow',
          licheng: '8000km',
          shixiao: 'Station to station about 14 days(days)',
          goBackPinCi: '4 times/month'
        },
        {
          startStation: 'Shijiazhuang-Moscow',
          licheng: '8000km',
          shixiao: 'Station to station about 14 days(days)',
          goBackPinCi: '4 times/month'
        }
      ],
      // 提供服务

      serviveItemsArr: {
        one: {
          titleImg: require("@/assets/chinaEurope/serve.png"),
          titleWord: "订舱服务",
          Desc: "提供中欧班列、中俄班列、中亚班列线路的订舱服务",
        },
        ones: {
          titleImg: require("@/assets/chinaEurope/serve.png"),
          titleWord: "进出口班列线路设计规划",
          Desc: "提供中欧、中俄、中亚班列线路优化设计方案，境内外全程运输方案 ",
        },
        oneE: {
          titleImg: require("@/assets/chinaEurope/serve.png"),
          titleWord: "Booking service",
          Desc: "Provide booking services for China-Europe, China-Russia, and Central Asia lines",
        },
        onesE: {
          titleImg: require("@/assets/chinaEurope/serve.png"),
          titleWord: "Design and planning of import and export trains",
          Desc: "Provide the optimized design scheme of China Europe, China Russia and Central Asia trains and the whole domestic and international transportation scheme ",
        },
        list: [
          {
            titleImg: require("@/assets/chinaEurope/serve.png"),
            titleWord: "集装箱租赁",
            Desc: "提供境内外去程集装箱租赁服务",
          },
          {
            titleImg: require("@/assets/chinaEurope/serve.png"),
            titleWord: "清关服务",
            Desc: "提供各类进出口专业关务服务",
          },
          {
            titleImg: require("@/assets/chinaEurope/serve.png"),
            titleWord: "单证服务",
            Desc: "为客户提供国际联运单证服务",
          },
          {
            titleImg: require("@/assets/chinaEurope/serve.png"),
            titleWord: "国内外拖车/平板",
            Desc: "为客户提供境内外集卡车门点服务",
          },
          {
            titleImg: require("@/assets/chinaEurope/serve.png"),
            titleWord: "地接服务",
            Desc: "提供方案预审，计划申请、堆区、发 运咨询等方面服务",
          },
          {
            titleImg: require("@/assets/chinaEurope/serve.png"),
            titleWord: "仓库/内装/堆存",
            Desc: "提供仓库装卸、堆存、保管、交接服务务",
          },
        ],
        listE: [
          {
            titleImg: require("@/assets/chinaEurope/serve.png"),
            titleWord: "Container leasing",
            Desc: "Provide domestic and overseas outbound container leasing services",
          },
          {
            titleImg: require("@/assets/chinaEurope/serve.png"),
            titleWord: "Customs clearance service",
            Desc: "Provide various import and export professional customs services",
          },
          {
            titleImg: require("@/assets/chinaEurope/serve.png"),
            titleWord: "Document service",
            Desc: "Provide customers with international transport document services",
          },
          {
            titleImg: require("@/assets/chinaEurope/serve.png"),
            titleWord: "Domestic and foreign trailers / flatbeds",
            Desc: "Provide customers with domestic and foreign truck door point services",
          },
          {
            titleImg: require("@/assets/chinaEurope/serve.png"),
            titleWord: "Ground service",
            Desc: "Provide program pre-review, plan application, stack area, shipping consultation and other services",
          },
          {
            titleImg: require("@/assets/chinaEurope/serve.png"),
            titleWord: "Warehouse / Interior / Stockpiling",
            Desc: "Provide warehouse loading and unloading, stockpiling, storage, handover services",
          },
        ],
      },
    };
  },
};
</script>

<style lang="less">
.chinaEuropeTrain {
  background-color: #fff;
}
.TopTitle {
  width: 92%;
  height: 4.95rem;
  position: relative;
  margin: 0 4%;
  top: -3.2rem;
  border-bottom: 1px solid rgba(204, 204, 204, 0.5);

  & > div {
    position: absolute;
    top: 1.25rem;
    font-size: 1rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    padding: 1.2rem 3.375rem 1.2rem 0.75rem;
    background: #2e67b1
      linear-gradient(270deg, rgba(3, 0, 0, 0.15), hsla(0, 0%, 100%, 0.15));
  }
}

.ContentText {
  width: 92%;
  margin: 0 4%;
  // background-color: #000066;
  margin-top: -1.575rem;
  text-align: left;

  & > p {
    font-size: 0.875rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-indent: 2em;
    margin-bottom: 1.25rem;
    text-align: justify;
  }
}

.ContenImg {
  width: 100%;
  height: 22rem;
  min-height: 22rem;
  margin-top: 2.0875rem;
  margin-bottom: 1.0875rem;

  & > img {
    width: 100%;
    height: 100%;
  }
}

.ContentDataNumber {
  width: 100%;

  margin-bottom: 1rem;
  position: relative;

  & > div {
    position: absolute;
  }

  .ContentDataNumberImage {
    width: 8.4375rem;
    height: 9.0625rem;
    bottom: 0;
    right: 0;

    & > img {
      width: 100%;
      height: 100%;
    }
  }

  .ContentDataNumberText {
    width: 70%;
    height: 100%;
    text-align: left;

    & > div {
      margin-left: 0.96875rem;
    }

    & > .title {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #2e67b1;
      margin-bottom: 0.8rem;
    }

    & > .text {
      width: 85%;
      font-size: 0.6875rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 1.5rem;
    }

    & > .number {
      width: 90%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      margin-top: 2rem;

      .numberList {
        margin-right: 10px;
        .numberText {
          font-size: 1.4625rem;
          font-family: AkzidenzGroteskBQ;
          font-weight: normal;
          color: #2d6aab;
          background: linear-gradient(180deg, #3676c9 0%, #42be72 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .numberName {
          font-size: 0.525rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
        }
      }
    }
  }
}

.tableTitleP {
  margin: 1.875rem 0 0.625rem 0;
  font-size: 0.95rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2e67b1;
  text-align: left;
}

.roadLine_bottom_L {
  width: 92%;
  height: 100%;
  margin: 0 4%;
  margin-top: 1.5625rem;

  // background: purple;
  .lineDiv {
    width: 100%;
    height: 2.5rem;
    // background: pink;
    display: flex;
    font-size: 0.725rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: left;
    padding: 5px 0px;

    & > p {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 5px;
      word-break: break-word;//文本超出 自动换行
    }

    .firstP {
      width: 7.5rem;
      // height: 100%;
      background: #f8f8f8;
    }

    .zhi {
      width: 1.5625rem;
      background: #f8f8f8;
      margin: 0 0.15625rem;
    }

    .thirdP {
      width: calc(100% - 120px - 25px);
      background: #f8f8f8;
    }
  }
}

.ButtomService {
  width: 92%;
  margin: 0 4%;

  img {
    width: 1.5625rem;
    height: 1.9375rem;
  }

  .topOne {
    width: 100%;
    box-shadow: 0px 0px 20px 0px rgba(41, 92, 169, 0.1);
    padding-bottom: 1.09375rem;
    margin-bottom: 0.625rem;
    margin-top: 0.9375rem;

    .topImg {
      display: flex;
      justify-content: flex-start;
      // align-items: flex-end;
      margin-left: 0.96875rem;
      font-size: 0.85rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #2e67b1;

      .topTitle {
        margin-left: 0.65625rem;
        margin-top: 5px;
      }
    }

    .topContent {
      margin-left: 0.96875rem;
      font-size: 0.725rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      margin-top: 1rem;
      text-align: left;
    }
  }

  .topTwo {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    .topTwoCon {
      width: 48.5%;
      // height: 4.6875rem;
      box-shadow: 0px 0px 20px 0px rgba(41, 92, 169, 0.1);
      padding-bottom: 1.09375rem;
      margin-bottom: 0.625rem;
      // margin-top: 0.9375rem;

      .topImg {
        display: flex;
        justify-content: flex-start;
        // align-items: flex-end;
        margin-left: 0.96875rem;
        font-size: 0.85rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2e67b1;

        .topTitle {
          margin-left: 0.65625rem;
        margin-top: 5px;

        }
      }

      .topContent {
        margin-left: 0.96875rem;
        font-size: 0.725rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-top: 1rem;
        text-align: left;
      }
    }
  }
}

.buttonImgCET {
  width: 100%;
  height: 3.125rem;
  margin-top: 0.78125rem;
}
</style>
